import Alert from '@mui/material/Alert';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, useSearchParams } from 'react-router-dom';
import { RentalCartView } from '../../../components/dashboard/rentals/newRental';
import { getCartsForUser } from '../../../redux/slices/rentals';
import { useDispatch, useSelector } from '../../../redux/store';

export default function RentalCart() {
  const dispatch = useDispatch();
  const { facilityId = '' } = useParams();
    const [urlParams] = useSearchParams();
  const punchoutFailed = urlParams.get('punchoutFailed'); 
  const {
    data: { cart },
  } = useSelector((state) => state.rentals);

  useEffect(() => {
    if (!cart.length) {
      dispatch(getCartsForUser());
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>Rental Cart | Platform Solutions</title>
      </Helmet>
       {punchoutFailed === "true" ? <Alert severity="error" sx={{ mt: 1 }}>Punchout failed.</Alert> :
      <RentalCartView facilityId={facilityId} />}
    </>
  );
}
